import { useState } from "react";
import { login, signup } from "../authApi";

export function AuthPanel({ onDone, onCancel, reason }: { onDone: (email: string) => void; onCancel: () => void; reason?: string }) {
  const [mode, setMode] = useState<"login" | "signup">("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit() {
    setBusy(true);
    setErr(null);
    try {
      const r = mode === "login" ? await login(email.trim(), password) : await signup(email.trim(), password);
      onDone(r.email);
    } catch (e: any) {
      setErr(String(e.message).slice(0, 140));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal-back" onClick={onCancel}>
      <div className="modal" style={{ width: 380 }} onClick={(e) => e.stopPropagation()}>
        <div className="glabel">{mode === "login" ? "Sign in" : "Create account"}</div>
        {reason && <div className="hint">{reason}</div>}
        <label><span className="lbl">Email</span><input type="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} /></label>
        <label><span className="lbl">Password {mode === "signup" && "(min 8 characters)"}</span><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} /></label>
        {err && <div className="hint" style={{ color: "#a3402f" }}>{err}</div>}
        <div style={{ display: "flex", gap: 8, marginTop: 10, alignItems: "center" }}>
          <button className="dark" onClick={submit} disabled={busy || !email.trim() || !password}>{busy ? <span className="spinner" /> : mode === "login" ? "Sign in" : "Create account"}</button>
          <button onClick={onCancel}>Cancel</button>
          <div style={{ flex: 1 }} />
          <button className="link" onClick={() => { setErr(null); setMode(mode === "login" ? "signup" : "login"); }}>{mode === "login" ? "Create account" : "Have an account? Sign in"}</button>
        </div>
      </div>
    </div>
  );
}
